
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.addEventListener('click', (event) => {
      if (event.target.classList.contains('cart-drawer__clear')) {
        this.clearCart();
      }
    });

  }


   async clearCart() {
    // Don't proceed if cart is already empty
    if (this.classList.contains('is-empty')) return;
    
    try {
      // Show loading state
      this.classList.add('loading');
      
      // Clear the cart via Shopify API
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      
      if (response.ok) {
        // Refresh the cart drawer to show empty state
        await this.refreshCart();
        
        // Manually set empty state classes
        this.classList.add('is-empty');
        const drawerInner = this.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.add('is-empty');
        
        const drawerInnerEmpty = this.querySelector('.drawer__inner-empty');
        if (drawerInnerEmpty) drawerInnerEmpty.classList.add('is-empty');
        
        // Focus on close button or empty cart message
        const focusElement = this.querySelector('.drawer__close') || 
                            this.querySelector('.cart__empty-text');
        if (focusElement) focusElement.focus();
      } else {
        throw new Error('Failed to clear cart');
      }
    } catch (error) {
      console.error('Error clearing cart:', error);
      const errorElement = this.querySelector('#CartDrawer-CartErrors');
      if (errorElement) {
        errorElement.textContent = 'Failed to clear cart. Please try again.';
        errorElement.style.display = 'block';
      }
    } finally {
      this.classList.remove('loading');
    }
  }

  async refreshCart() {
    try {
      const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const text = await response.text();
      const json = JSON.parse(text);
      
      this.renderContents({
        id: 'cart-drawer',
        sections: json
      });
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // Existing empty class handling remains unchanged
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });


     // Ensure empty state is properly handled after render
      const cartItems = this.querySelector('[data-cart-items]');
      if (cartItems && cartItems.children.length === 0) {
        const drawerInner = this.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.add('is-empty');
        
        const drawerInnerEmpty = this.querySelector('.drawer__inner-empty');
        if (drawerInnerEmpty) drawerInnerEmpty.classList.add('is-empty');
      }
  }


  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);





